import React from 'react'

const WalletsInfo = () => {
  return (
    <div>WalletsInfo</div>
  )
}

export default WalletsInfo